<body>
<app-header></app-header>
<app-loading-spinner></app-loading-spinner>
<app-notifications></app-notifications>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-theme-switcher></app-theme-switcher>
</body>

